// Styled Components
import styled from "styled-components";

// Components
import GenerateText from "./GenerateText/GenerateText";
import GenerateForm from "./GenerateForm/GenerateForm";
import GenerateItems from "./GenerateItems/GenerateItems";

const Generate = () => {
  return (
    <Wrapper id="generate">
      <div className="background"></div>

      <GenerateText />
      <GenerateItems />
    </Wrapper>
  );
};

export default Generate;

const Wrapper = styled.div`
  padding: 0 20px;
  padding-top: 150px;
  margin: 0 auto;

  position: relative;

  .background {
    width: 500vw;
    top: 0;
    height: 100%;
    position: absolute;
    left: -200%;
    background-color: #000;
    z-index: 100;
  }

  width: 1275px;

  @media only screen and (max-width: 1275px) {
    width: 100%;
  }

  //
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-direction: column;
  @media only screen and (max-width: 1075px) {
    gap: 50px;
  }
  //
`;
